import { useEffect } from 'react'

import { useBoundStore } from '../store/store'
import type { ApiResponse } from '../types/api'
import { api } from '../utils/api-client'

interface DepositEvent {
  account: string
  amount: string
  bank_account: string
  bank_account_name: string
  billno: string
  cardID: string
  checkPerson: string
  depStatus: string
  endTime: string
  fee: string
  for_bankverify: string
  id: string
  payType: string
  platInfo: string
  requestTime: string
  saveName: string
  saveTime: string
  userType: string
  is_first_deposit: number
}

const useDepositEvents = () => {
  const username = useBoundStore(state => state.user.username)

  useEffect(() => {
    if (!username) return
    const getDepositEvents = async () => {
      try {
        const res = await api.post<ApiResponse<DepositEvent[]>>(
          '/conduct.php',
          {
            type: 'get_new_successful_deposits',
          },
        )
        const { status, info } = res.data
        if (status === 1 && info.length >= 1) {
          await api.post('/conduct.php', {
            type: 'clear_new_successful_deposits',
          })
        }
      } catch (error) {
        console.error(error)
      }
    }

    getDepositEvents()
  }, [username])
}

export default useDepositEvents
